export default {
  common: {
    readMore: 'ニュース一覧',
    contactUs: 'お問い合わせ',
    getInTouch: 'お問い合わせ',
    sendInquiry: 'お問い合わせを送る',
    back: '戻る',
    backToNews: 'ニュースに戻る',
    backToNewsList: 'ニュース一覧に戻る',
    clearSearch: '検索をクリア',
    search: '検索',
    noResults: '結果が見つかりませんでした',
    required: '必須',
    submit: '送信',
    submitting: '送信中...',
    showing: '表示中',
    of: '/',
    products: '件',
    all: '全て',
  },
};
